/**
 * Content schedule: show block only between publish and end; otherwise show default.
 * Uses section-level publish/end time and timezone (IANA e.g. America/New_York).
 */
(function () {
  function pad(n) { return String(n).padStart(2, '0'); }

  /**
   * Current date/time as YYYY-MM-DDTHH:MM for comparison.
   * When tz is set, returns time IN that IANA timezone (any zone; DST handled by engine).
   * When tz is empty, returns visitor's local time.
   * Uses formatToParts so we never depend on locale string format (avoids regex/hyphen vs slash issues).
   */
  function nowString(tz) {
    var d = new Date();
    if (!tz) {
      return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + 'T' + pad(d.getHours()) + ':' + pad(d.getMinutes());
    }
    try {
      var opts = {
        timeZone: tz,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        hourCycle: 'h23'
      };
      var formatter = new Intl.DateTimeFormat('en-CA', opts);
      var parts = formatter.formatToParts(d);
      var getPart = function (type) {
        var p = parts.find(function (x) { return x.type === type; });
        return p ? p.value : '';
      };
      var y = getPart('year');
      var mo = getPart('month');
      var day = getPart('day');
      var h = getPart('hour');
      var min = getPart('minute');
      if (y && mo && day && h !== '' && min !== '') {
        return y + '-' + pad(parseInt(mo, 10)) + '-' + pad(parseInt(day, 10)) + 'T' + pad(parseInt(h, 10)) + ':' + pad(parseInt(min, 10));
      }
    } catch (_) {}
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + 'T' + pad(d.getHours()) + ':' + pad(d.getMinutes());
  }

  function dateTimeStr(dateStr, timeStr) {
    if (!dateStr || !timeStr) return null;
    var t = timeStr.trim().match(/^(\d{1,2}):(\d{1,2})/);
    if (!t) return null;
    return dateStr.trim() + 'T' + pad(parseInt(t[1], 10)) + ':' + pad(parseInt(t[2], 10));
  }

  function apply(wrapper) {
    var d = wrapper.dataset;
    var timezone = (d.scheduleTimezone || '').trim();
    var publishStr = dateTimeStr(d.schedulePublishDate, d.schedulePublishTime);

    if (!publishStr) {
      wrapper.removeAttribute('style');
      wrapper.classList.remove('content-schedule--before', 'content-schedule--scheduled');
      wrapper.classList.add('content-schedule--default');
      return;
    }

    var now = nowString(timezone);
    var endStr = dateTimeStr(d.scheduleEndDate, d.scheduleEndTime);

    wrapper.removeAttribute('style');

    if (now < publishStr) {
      wrapper.classList.remove('content-schedule--before', 'content-schedule--scheduled');
      wrapper.classList.add('content-schedule--default');
      return;
    }
    if (endStr && now >= endStr) {
      wrapper.classList.remove('content-schedule--before', 'content-schedule--scheduled');
      wrapper.classList.add('content-schedule--default');
      return;
    }
    wrapper.classList.remove('content-schedule--before', 'content-schedule--default');
    wrapper.classList.add('content-schedule--scheduled');
  }

  function dateTimeMsLocal(dateTimeStr) {
    var m = dateTimeStr.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/);
    if (!m) return null;
    var y = parseInt(m[1], 10);
    var mo = parseInt(m[2], 10) - 1;
    var day = parseInt(m[3], 10);
    var h = parseInt(m[4], 10);
    var min = parseInt(m[5], 10);
    return new Date(y, mo, day, h, min).getTime();
  }

  function checkPublish(wrapper, publishStr, tz) {
    if (!tz) {
      var publishMs = dateTimeMsLocal(publishStr);
      if (publishMs != null) {
        var delay = publishMs - Date.now();
        if (delay > 0 && delay < 86400000) {
          setTimeout(function () {
            apply(wrapper);
            run();
            document.dispatchEvent(new CustomEvent('theme:resize:width', { bubbles: true }));
          }, delay);
          return;
        }
      }
    }
    function tick() {
      if (nowString(tz) >= publishStr) {
        apply(wrapper);
        run();
      } else {
        setTimeout(tick, 10000);
      }
    }
    setTimeout(tick, 10000);
  }

  function checkEnd(wrapper, endStr, tz) {
    if (!tz) {
      var endMs = dateTimeMsLocal(endStr);
      if (endMs != null) {
        var delay = endMs - Date.now();
        if (delay > 0 && delay < 86400000) {
          setTimeout(function () {
            apply(wrapper);
            run();
            document.dispatchEvent(new CustomEvent('theme:resize:width', { bubbles: true }));
          }, delay);
          return;
        }
      }
    }
    function tick() {
      if (nowString(tz) >= endStr) {
        apply(wrapper);
        run();
      } else {
        setTimeout(tick, 10000);
      }
    }
    setTimeout(tick, 10000);
  }

  function run() {
    var wrappers = document.querySelectorAll('[data-content-schedule-wrapper]');
    wrappers.forEach(function (wrapper) {
      apply(wrapper);
      var d = wrapper.dataset;
      var tz = (d.scheduleTimezone || '').trim();
      var publishStr = dateTimeStr(d.schedulePublishDate, d.schedulePublishTime);
      var endStr = dateTimeStr(d.scheduleEndDate, d.scheduleEndTime);
      var now = nowString(tz);
      if (publishStr && now < publishStr) checkPublish(wrapper, publishStr, tz);
      else if (endStr && now < endStr) checkEnd(wrapper, endStr, tz);
    });
    document.dispatchEvent(new CustomEvent('theme:resize:width', { bubbles: true }));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
